import BaseModel from './BaseModel';
import * as AT from '../../components/container/attributes';

export default class ResourceData extends BaseModel {
  constructor({id, number, designation}) {
    super(id, number, designation);
  }

  static get fkName() {
    return undefined;
  }
  static get apiRoute() {
    return 'resource_data';
  }
  static get detailPageRoute() {
    return undefined;
  }
  static get listPageRoute() {
    return undefined;
  }
  get fkName() {
    return ResourceData.fkName;
  }
  get apiRoute() {
    return ResourceData.apiRoute;
  }
  get listPageRoute() {
    return ResourceData.listPageRoute;
  }
  get detailPageRoute() {
    return ResourceData.detailPageRoute;
  }

  static get joinAttrsKey() {
    return ['number', 'designation', 'percentage'];
  }

  static get entityListDisplayAttrs() {
    return [
      'designation',
      'unit',
      'quantity',
      'netPrice',
      'grossPrice',
      'grossAmount',
      'comment',
      'scriptSource',
    ];
  }

  static get entityListHiddenAttrs() {
    return [
      'resourceOrigin',
      'resourceTarget',
      'composite',
      'unfold',
      'customisable',
      'margin',
      'active',
      'netAmount',
      'quantityExpression',
      'quantityCalculated',
      'validExpression',
      'pricePrecision',
      'sortOrder',
    ];
  }

  static get entityListAttrs() {
    return this.getAttributes(
      this.entityListDisplayAttrs,
      this.entityListHiddenAttrs,
    );
  }

  static get allAttributes() {
    return [
      this.DESIGNATION_ATTRIBUTE({}, {maxWidth: '1.5fr'}),
      this.ACTIVE_ATTRIBUTE(),
      new AT.FkResourceAttribute({
        name: 'resourceTarget',
        joinPath: ['resource!fk_resource_data_resource_id_resource'],
        fkToUpdate: 'resource_id',
        tableProperties: {
          header: 'hit-base.common.resource',
        },
      }),
      new AT.FkResourceAttribute({
        name: 'resourceOrigin',
        column: 'data_resource_id',
        joinPath: ['resource!fk_resource_data_data_resource_id_resource'],
        fkToUpdate: 'data_resource_id',
        tableProperties: {
          header: 'hit-base.common.resource',
        },
      }),
      new AT.IntegerAttribute({
        readOnly: true,
        name: 'pricePrecision',
        column:
          'resource!fk_resource_data_data_resource_id_resource(price_precision)',
        transform: (data) => data?.price_precision ?? 0,
      }),
      new AT.FkUnitAttribute({
        name: 'unit',
        joinPath: ['unit!fk_resource_data_unit_id_unit'],
        tableProperties: {
          header: 'hit-base.common.unit',
          maxWidth: '0.6fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'customisable',
        tableProperties: {
          header: 'hit-app.common.customisable',
        },
      }),
      new AT.BooleanAttribute({
        name: 'composite',
        tableProperties: {
          header: 'hit-app.resource.composite',
          maxWidth: '1fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'unfold',
        tableProperties: {
          header: 'hit-app.resource.unfold',
        },
      }),
      new AT.DecimalAttribute({
        name: 'quantity',
        creationValue: 0,
        tableProperties: {
          header: 'hit-app.common.quantity',
          maxWidth: '1.2fr',
        },
      }),
      new AT.StringAttribute({
        name: 'quantityExpression',
        column: 'quantity_expression',
        tableProperties: {
          header: 'hit-app.transaction.expression',
        },
      }),
      new AT.BooleanAttribute({
        name: 'validExpression',
        column: 'valid_expression',
      }),
      new AT.BooleanAttribute({
        name: 'quantityCalculated',
        column: 'quantity_calculated',
      }),
      new AT.DecimalAttribute({
        name: 'netPrice',
        column: 'net_price',
        decimalPrecisionForcedByColumn: 'pricePrecision',
        creationValue: 0.0,
        tableProperties: {
          header: 'hit-app.common.net-price-short',
          maxWidth: '0.9fr',
          hideByDefault: true,
        },
      }),
      new AT.DecimalAttribute({
        name: 'netAmount',
        decimalPrecision: 2,
        column: 'net_amount',
        readOnly: true,
        default: 0.0,
        tableProperties: {
          header: 'hit-app.common.net-amount-short',
          maxWidth: '0.25fr',
        },
      }),
      new AT.DecimalAttribute({
        name: 'grossPrice',
        decimalPrecisionForcedByColumn: 'pricePrecision',
        column: 'gross_price',
        default: 0.0,
        tableProperties: {
          header: 'hit-app.common.gross-price-short',
          maxWidth: '0.9fr',
        },
      }),
      new AT.DecimalAttribute({
        name: 'grossAmount',
        decimalPrecision: 2,
        column: 'gross_amount',
        default: 0.0,
        readOnly: true,
        tableProperties: {
          header: 'hit-app.common.gross-amount-short',
          maxWidth: '1fr',
        },
      }),
      new AT.DecimalAttribute({
        name: 'margin',
        decimalPrecision: 4,
        creationValue: 1,
        tableProperties: {
          header: 'hit-app.common.base-margin',
        },
      }),
      new AT.StringAttribute({
        name: 'comment',
        tableProperties: {
          header: 'hit-base.common.comment-short',
          maxWidth: '1fr',
        },
      }),
      new AT.StringAttribute({
        name: 'scriptSource',
        column: 'script_source',
        tableProperties: {
          header: 'ONLY_SHOW_IN_EDITION',
        },
      }),
      new AT.NumberAttribute({
        name: 'sortOrder',
        column: 'sort_order',
        readOnly: true,
      }),
    ];
  }
}
